import rest from './lib';

export default rest;
